import { compareWithInitVal } from '../../../../../../shared/lib/formFieldValidators';

export const getValidationRules = ({ initialValue, editMode, enableAlisa }) =>
  editMode
    ? [
        {
          required: true,
          message: 'Введите текст',
          whitespace: true,
        },
        {
          validator: compareWithInitVal(initialValue ?? ''),
        },
      ]
    : [
        {
          required: typeof enableAlisa === 'boolean' ? enableAlisa : false,
          message: 'Введите текст',
        },
      ];
